import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {fileDimensions, fileSizeMB} from '../utils';
import ReactTooltip from 'react-tooltip';
import size from 'lodash/size';
import maxBy from 'lodash/maxBy';
import dateFormat from 'dateformat';
import {connect} from 'react-redux';
import {imageContextSelector} from '../reducers/imageContextSelector';


export const createTooltipId = (imageId) => {
    return `infoTooltip-${imageId}`;
};

@connect((state, ownProps) => ({imageContext: imageContextSelector(state, ownProps.id)}))
export default class ImageInfoTooltip extends Component {
    static propTypes = {
        id: PropTypes.number,
        imageContext: PropTypes.object,
        showEditInfo: PropTypes.bool,
    };

    render() {
        const {imageContext: {imageInfo, imageEditHistory}, showEditInfo, id, ...rest} = this.props;
        if (!imageInfo) {
            return false;
        }
        let editInfo;
        if (showEditInfo) {
            const edits = (imageEditHistory.edits || []).filter(historyItem => !historyItem.deleted);
            const editCount = size(edits);
            const lastEdited = editCount > 0 ? dateFormat(new Date(maxBy(edits, 'dateCreated').dateCreated)) : 'never';
            editInfo = [
                <tr key="edits">
                    <th>{'Edits'}</th>
                    <td>{editCount}</td>
                </tr>,
                <tr key="lastEdited">
                    <th>{'Last edited'}</th>
                    <td>{lastEdited}</td>
                </tr>
            ]
        }

        return (
            <ReactTooltip id={createTooltipId(id)} place="bottom" delayShow={400} type="dark" {...rest}>
                <table className="image-info">
                    <tbody>
                    <tr>
                        <th>{'Name'}</th>
                        <td>{imageInfo.fileName}</td>
                    </tr>
                    <tr>
                        <th>{'Size'}</th>
                        <td>{fileSizeMB(imageInfo.fileSize)}</td>
                    </tr>
                    <tr>
                        <th>{'Dimensions'}</th>
                        <td>{fileDimensions(imageInfo)}</td>
                    </tr>
                    <tr>
                        <th>{'Uploaded'}</th>
                        <td>{dateFormat(new Date(imageInfo.uploadTime))}</td>
                    </tr>
                    {editInfo}
                    </tbody>
                </table>
            </ReactTooltip>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/ImageInfoTooltip.js